import Http from '../utils/http'
import store from 'store/index'

export const create = (payload) => {
    return Http.post(`/company/members`, payload)
       .then(response => {
           store.dispatch('saveMember', response.data)
           return response.data
       })
}

export const reactivate = (id, payload) => {
    return Http.put(`/company/members/${id}/reactivate`, payload)
               .then(response => {
                   store.dispatch('saveMember', response.data)
                   return response.data
               })
}

export const inactivate = (id) => {
    return Http.put(`/company/members/${id}/inactivate`)
               .then(response => {
                   store.dispatch('saveMember', response.data)
                   return response.data
               })
}

export const setAsAdmin = (id) => {
    return Http.put(`/company/members/${id}/set-as-admin`)
               .then(response => {
                   store.dispatch('saveMember', response.data)
                   return response.data
               })
}

export const unsetAsAdmin = (id) => {
    return Http.put(`/company/members/${id}/unset-as-admin`)
               .then(response => {
                   store.dispatch('saveMember', response.data)
                   return response.data
               })
}



// WEBPACK FOOTER //
// ./src/services/members.js